<template>
  <div class="editCellTable d-flex align-items-center">
    <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center">
      <CSpinner class="my-3" color="primary" />
    </div>
    <div class="d-flex" v-if="cell.isKey">
      <CInput
        type="text"
        :readonly="true"
        addWrapperClasses="addWrapperClasses"
        :value="cell.value"
        class="m-0"
      >
        <template #prepend>
          <CIcon name="key" :height="18" viewBox="0 0 32 32" />
        </template>
      </CInput>
    </div>
    <CInput
      v-else
      :readonly="!edit"
      type="text"
      v-model.trim="newValue"
      :invalidFeedback="'Required'"
      addWrapperClasses="addWrapperClasses"
      required
      class="m-0"
      ref="inputEdit"
    >
      <template #append>
        <span class="h-100 d-flex align-items-center" @click="focusEdit()">
          <CIcon name="editFull" :height="18" class="px-3 icon-edit" viewBox="0 0 32 32" />
        </span>

        <div v-if="edit" class="editCellTable__inputActions ml-2 d-flex align-items-center">
          <CButton
            :disabled="!newValue.length"
            color="primary"
            class="px-4 py-1"
            @click="validateField(cell)"
          >
            {{ $t('audience.customFields.button.save') }}
          </CButton>
          <CButton color="trasparent" type="link" @click="cancel(cell)">
            {{ $t('audience.customFields.button.cancel') }}
          </CButton>
        </div>
      </template>
    </CInput>
  </div>
</template>

<script>
import services from '@/services.js'

export default {
  name: 'EditCellTable',
  props: {
    cell: {
      type: Object,
      required: true
    },
    types: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      newValue: this.cell.value,
      edit: false
    }
  },

  methods: {
    focusEdit() {
      this.edit = true
      this.$nextTick(() => {
        this.$refs.inputEdit.$el.childNodes[0].childNodes[1].focus()
      })
    },

    save(body) {
      this.loading = true
      this.edit = false
      this.messages = []
      services
        .patchFieldtypes(this.$store.state.auth.organizationId, { ...body })
        .then(() => {
          this.sendMenssage({
            status: 'success',
            text: 'The field was renamed'
          })
          this.$emit('saveItem', { columnkey: this.cell.key, newColumnName: this.newValue })
        })
        .catch(err => {
          this.newValue = this.cell.value
          this.sendMenssage({
            status: 'danger',
            text: err.response.data.message
          })
        })
        .finally(() => {
          this.loading = false
          this.edit = false
        })
    },

    cancel(cell) {
      this.newValue = cell.value
      this.edit = false
    },

    validateField() {
      this.loading = true
      const hasRepeat = this.types.some(
        type => this.newValue.trim().toUpperCase() == type.value.trim().toUpperCase()
      )

      if (hasRepeat) {
        this.sendMenssage({
          status: 'danger',
          text: this.$t('audience.customFields.table.message.name-type-already-exists')
        })
        this.newValue = this.cell.value
        this.loading = false
        return
      }

      this.save({ columnkey: this.cell.key, newColumnName: this.newValue })
    },

    sendMenssage(body) {
      this.$emit('sendMenssage', body)
    }
  }
}
</script>

<style lang="scss">
.editCellTable {
  .addWrapperClasses {
    display: flex;
  }

  .form-control {
    color: $gray-600;
    &:hover,
    &:focus {
      box-shadow: none !important;
      color: $gray-700;
    }

    &:focus {
      border-bottom: 1px solid $gray-700;

      + .input-group-append {
        span {
          border-bottom: 1px solid $gray-700;
          background: $white;
        }

        .editCellTable__inputActions {
          opacity: 1;
          pointer-events: initial;
        }
      }
    }
  }

  .input-group-append {
    align-items: center;
  }

  .input-group-prepend {
    align-items: center;
  }

  input:read-only {
    background: transparent;
    display: inline;
    &:hover {
      box-shadow: none;
    }
  }
}
</style>
